/** API client for dashboard KPI + sparkline metrics. */
import { apiClient } from '../api-client'

export type SparkSeriesPoint = { date: string; y: number }

export interface MetricSeries {
  series: SparkSeriesPoint[]
  delta_7d: number
}

export interface DashboardMetrics {
  images_this_week: number
  images: MetricSeries
  products: MetricSeries
  credits: MetricSeries
}

export async function getDashboardMetrics(): Promise<DashboardMetrics> {
  const response = await apiClient.get<{ success: boolean; metrics: DashboardMetrics }>(
    '/api/v1/dashboard/metrics?days=30',
  )
  return response.data.metrics
}
